export default __webpack_public_path__ + "static/media/ordered_list_icon_white.716b531d.svg";